import { BreadcrumbGroup } from '@cloudscape-design/components';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMemo, useCallback } from 'react';
import React from 'react';
import routePaths from 'src/contstant/routePaths';

const AppBreadcrumbs = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Memoize the path segments calculation
  const pathSegments = useMemo(
    () => location.pathname.split('/').filter(Boolean),
    [location.pathname],
  );

  // Memoize the text transformation function
  const formatText = useCallback(
    (path: string) =>
      Object.values(routePaths).find((route) => route.path.includes(path))?.title || '',
    [],
  );

  // Memoize the breadcrumb items
  const breadcrumbItems = useMemo(() => {
    // Don't show breadcrumbs on the home page
    if (location.pathname === '/') {
      return [];
    }

    const items = [{ text: 'Home', href: '/' }];

    pathSegments.forEach((segment, index) => {
      const href = `/${pathSegments.slice(0, index + 1).join('/')}`;
      items.push({
        text: formatText(segment),
        href,
      });
    });

    return items;
  }, [pathSegments, formatText, location.pathname]);

  return (
    <BreadcrumbGroup
      data-testid="breadcrum-group"
      onFollow={(event) => {
        if (!event.detail.external) {
          event.preventDefault();
          navigate(event.detail.href);
        }
      }}
      items={breadcrumbItems}
    />
  );
};

export default React.memo(AppBreadcrumbs);
